import { ErgonomicToolNames, ErgonomicToolKeys, EvaluationCategoryKeys, EvaluationCategoryNames } from '../../enums';

interface CategoriesToolsProps {
	category_key: string;
	category_name: string;
	tool: string | null;
	name: string | null;
}

export const CATEGORIES_TOOLS: CategoriesToolsProps[] = [
	{
		category_key: EvaluationCategoryKeys.LIFT_AND_LOWER,
		category_name: EvaluationCategoryNames.LIFT_AND_LOWER,
		tool: ErgonomicToolKeys.NIOSH,
		name: ErgonomicToolNames.NIOSH
	},
	{
		category_key: EvaluationCategoryKeys.PUSH_PULL,
		category_name: EvaluationCategoryNames.PUSH_PULL,
		tool: ErgonomicToolKeys.KIM_PP,
		name: ErgonomicToolNames.KIM_PP
	},
	{
		category_key: EvaluationCategoryKeys.TRANSPORT,
		category_name: EvaluationCategoryNames.TRANSPORT,
		tool: ErgonomicToolKeys.LIBERTY_MUTUAL,
		name: ErgonomicToolNames.LIBERTY_MUTUAL
	},
	{
		category_key: EvaluationCategoryKeys.REPETITIVE_MOVEMENTS,
		category_name: EvaluationCategoryNames.REPETITIVE_MOVEMENTS,
		tool: ErgonomicToolKeys.STRAIN_INDEX,
		name: ErgonomicToolNames.STRAIN_INDEX
	},
	{
		category_key: EvaluationCategoryKeys.FORCED_POSTURE,
		category_name: EvaluationCategoryNames.FORCED_POSTURE,
		tool: ErgonomicToolKeys.REBA,
		name: ErgonomicToolNames.REBA
	},
	{
		category_key: EvaluationCategoryKeys.HAND_ARM_VIBRATION,
		category_name: EvaluationCategoryNames.HAND_ARM_VIBRATION,
		tool: ErgonomicToolKeys.JDS_D86,
		name: ErgonomicToolNames.JDS_D86
	},
	{
		category_key: EvaluationCategoryKeys.WHOLE_BODY_VIBRATION,
		category_name: EvaluationCategoryNames.WHOLE_BODY_VIBRATION,
		tool: ErgonomicToolKeys.JDS_D86,
		name: ErgonomicToolNames.JDS_D86
	},
	{
		category_key: EvaluationCategoryKeys.THERMAL_COMFORT,
		category_name: EvaluationCategoryNames.THERMAL_COMFORT,
		tool: null,
		name: null
	},
	{
		category_key: EvaluationCategoryKeys.CONTACT_STRESS,
		category_name: EvaluationCategoryNames.CONTACT_STRESS,
		tool: null,
		name: null
	},
	{
		category_key: EvaluationCategoryKeys.STANDING,
		category_name: EvaluationCategoryNames.STANDING,
		tool: null,
		name: null
	}
];
